{
  "title": "Blur",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level illusion",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Your body becomes blurred, shifting and wavering to all who can see you. For the duration, any creature has disadvantage on attack rolls against you. An attacker is immune to this effect if it doesn't rely on sight, as with blindsight, or can see through illusions, as with truesight."
  ],
  "spellLists": ["artificer", "arcane-trickster", "sorcerer", "wizard"]
}
